import { render, staticRenderFns } from "./MessageTemplateByProductCategories.vue?vue&type=template&id=ff3e9864&scoped=true"
import script from "./MessageTemplateByProductCategories.vue?vue&type=script&lang=js"
export * from "./MessageTemplateByProductCategories.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplateByProductCategories.vue?vue&type=style&index=0&id=ff3e9864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3e9864",
  null
  
)

export default component.exports